var _a;
import { createStore } from 'redux';
import { create } from 'redux-react-hook';
import reducer from './reducer';
export var ActionEnum;
(function (ActionEnum) {
    ActionEnum[ActionEnum["SET_VISIBILITY"] = 0] = "SET_VISIBILITY";
    ActionEnum[ActionEnum["RESET_FIELD"] = 1] = "RESET_FIELD";
    ActionEnum[ActionEnum["SET_FIELD_OPTIONS"] = 2] = "SET_FIELD_OPTIONS";
    ActionEnum[ActionEnum["SET_VALUE"] = 3] = "SET_VALUE";
    ActionEnum[ActionEnum["SET_VALUES"] = 4] = "SET_VALUES";
    ActionEnum[ActionEnum["SET_CONSTRAINTS"] = 5] = "SET_CONSTRAINTS";
})(ActionEnum || (ActionEnum = {}));
export function makeStore() {
    return createStore(reducer, INITIAL_STATE);
}
export var INITIAL_STATE = {
    constraints: {},
    fieldsOptions: {},
    resetFields: {},
    values: {},
    visibleFieldList: [],
};
export var StoreContext = (_a = create(), _a.StoreContext), useDispatch = _a.useDispatch, useMappedState = _a.useMappedState;
//# sourceMappingURL=store.js.map